//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatTime, downloadFile } from '../../components/helpers.js'
import { mapGetters } from 'vuex'
import { axiosGet, axiosPost } from '../../axios/axios'
import FilesField from '../../components/File/FilesField.vue'
import FilesFieldUploadFromMessengers from '../../components/File/FilesFieldUploadFromMessengers.vue'

import ReportFilesGroup from './ReportFilesGroup.js'
import ReportImagesRemark from './ReportImagesRemark.vue'
import ReportImageRemark from './ReportImageRemark.vue'
import { reportFiles } from './ReportFiles.js'
import { isImageDocument } from '../../components/File/FileUtils.js'
import ReportContentSection from './ReportContent/ReportContentSection.vue'

export default {
  components: {
    ReportImagesRemark,
    FilesField,
    ReportContentSection
  },
  mixins: [reportFiles],
  props: {
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    },
    isAudit: {
      type: Boolean,
      default: false
    },
    hideEmptyOnReadonly: {
      type: Boolean,
      default: false
    },
    reportMinimal: {
      type: Boolean,
      default: false
    },
    hideCategories: {
      type: Array, // Список ключей
      default: null
    }
  },
  data: function () {
    return {
      FILES_PROPERTY: 'guiImgFiles', // !!!
      excludeCategoriesKeys: ['cityTgBot'],
      categories: [],
      expansionCategories: {},
      sizeImg: 140,

      loadingFromMessengers: {}
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      getSectionIcon: 'reportContent/getSectionIcon'
    }),
    executorName: function () {
      if (this.report.brigadeName) {
        let executorName = this.report.brigadeName
        if (!this.report.brigadeIsContractor && this.report.brigadeEmployees.length) {
          executorName += ' (' + this.report.brigadeEmployees.map(employee => employee.fio).join(', ') + ')'
        }
        return executorName
      } else {
        const executor = this.report.executor
        return executor && (executor.fio || executor.login) || ''
      }
    },
    hasForkliftTrucks: function () {
      return this.report.forkliftTrucks.length && !this.report.forkliftTrucksAbsent
    },
    mobileDevice: function () {
      return document.body.classList.contains('mobile') || document.body.classList.contains('native-mobile')
    },
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    displayDownloadAllImagesBtn: function () {
      // return !!(this.reportRoles.roleDispatcherOrHigher || this.reportRoles.roleReportCheckerOrHigher)
      if (!(this.mobileDevice && this.mobile)) {
        if (this.reportRoles.roleDispatcherOrHigher || this.reportRoles.roleReportCheckerOrHigher) {
          return true
        }
        const user = this.$store.getters.getUser
        if (user.hasOperation('exportRequestReportFiles')) {
          return true
        }
        const externalEmployee = !!(user.employee && user.employee.external && !user.isContractor)
        const publicationReadAccess = !!user.hasSystemRoleStrict('publicationRead') || user.restrictedAccess // TODO убрать после реализации частичной выгрузки доступных фотографий
        return !externalEmployee && !publicationReadAccess
      }
      return false
    }
  },
  watch: {
    hasForkliftTrucks: function (value) {
      if (this.categoriesMap && this.report.requiredPhotoCategories.includes('additionalVehicles')) {
        const category = this.categoriesMap.additionalVehicles
        if (category) {
          this.$set(category, 'required', value)
        }
      }
    }
  },
  mounted: function () {
    if (this.mobile) {
      const maxClientWidth = document.getElementById('report-images-div').clientWidth
      if (maxClientWidth > 0) {
        const photoRowWidth = maxClientWidth - 16 // Не получилось взять ширину нужного элемента (не сразу рисуется), поэтому берется родительский и вычетаются все padding/margin
        const photoMargin = 4
        const marginBetween = 2
        // photoRowWidth = (photoMargin + sizeImg + photoMargin) + marginBetween + (photoMargin + sizeImg + photoMargin)
        const sizeImg = Math.floor((photoRowWidth - marginBetween) / 2 - 2 * photoMargin)
        this.sizeImg = Math.min(sizeImg, this.sizeImg)
      }
    }
  },
  created: function () {
    this.prepareImages()
  },
  methods: {
    getCategoryIcon (categoryKey) {
      if (typeof this.getSectionIcon !== 'function') {
        return null
      }
      return this.getSectionIcon(`report-photos-category-${categoryKey}`)
    },
    getCategoryWeight (categoryKey) {
      const weights = {
        dispatcher: 615,
        vehicle: 620,
        video: 625,
        additionalVehicles: 630,
        beforeWorkExecution: 635,
        duringWorkExecution: 640,
        afterWorkExecution: 645,
        audit: 650,
        advertisements: 655,
        forAuditRequest: 660,
        other: 670
      }
      return weights[categoryKey] || 999
    },
    onCategoryOpenChange (categoryKey, val) {
      this.$set(this.expansionCategories, categoryKey, !!val)
    },
    prepareImages: function () {
      this.initialized = false
      if (this.report.documentsCategories && this.report.documentsCategories.length) {
        this.report.documentsCategories.forEach(category => {
          if (category.photo && !this.excludeCategoriesKeys.includes(category.key)) {
            const readonly = category.key === 'dispatcher'
            let required = this.report.requiredPhotoCategories.includes(category.key)
            if (required && category.key === 'additionalVehicles') {
              required = this.hasForkliftTrucks
            }
            this.categories.push(new ReportFilesGroup({ categoryKey: category.key, title: category.name.toUpperCase(), readonly: readonly, required: required, remarkIndex: category.remarkIndex })) // TODO remarkIndex
          }
        })
      } else {
        if (this.report.activePhotoCategories.includes('dispatcher')) {
          this.categories.push(new ReportFilesGroup({ categoryKey: 'dispatcher', title: 'ФОТО ИЗ ЗАЯВКИ', readonly: true })) // !this.reportRoles.roleDispatcherOrHigher
        }
        if (this.report.activePhotoCategories.includes('vehicle')) {
          this.categories.push(new ReportFilesGroup({ categoryKey: 'vehicle', title: 'ПАРКОВКА И ВЫГОРОДКА ТС' }))
        }
        if (this.report.activePhotoCategories.includes('video')) {
          this.categories.push(new ReportFilesGroup({ categoryKey: 'video', title: 'ВИДЕО' }))
        }

        if (this.report.activePhotoCategories.includes('additionalVehicles')) {
          let showAdditionalVehicles = !!this.report.forkliftTrucks.length
          if (!showAdditionalVehicles) {
            showAdditionalVehicles = this.report.documents.find(document => document.category === 'additionalVehicles' && isImageDocument(document)) != null
          }
          if (showAdditionalVehicles) {
            this.categories.push(new ReportFilesGroup({
              categoryKey: 'additionalVehicles',
              title: 'ДОПОЛНИТЕЛЬНАЯ ТЕХНИКА'
              // required: this.hasForkliftTrucks
            }))
          }
        }

        if (!this.isAudit) {
          if (this.report.activePhotoCategories.includes('beforeWorkExecution')) {
            this.categories.push(new ReportFilesGroup({ categoryKey: 'beforeWorkExecution', title: 'ДО ВЫПОЛНЕНИЯ РАБОТ' }))
          }
          if (this.report.activePhotoCategories.includes('duringWorkExecution')) {
            this.categories.push(new ReportFilesGroup({ categoryKey: 'duringWorkExecution', title: 'В ПРОЦЕССЕ ВЫПОЛНЕНИЯ РАБОТ' }))
          }
          if (this.report.activePhotoCategories.includes('afterWorkExecution')) {
            this.categories.push(new ReportFilesGroup({ categoryKey: 'afterWorkExecution', title: 'ПОСЛЕ ВЫПОЛНЕНИЯ РАБОТ' }))
          }
        }

        const showAuditAndAds = !(this.serviceObject && this.serviceObject.type && this.serviceObject.type.key === 'TOI')
        if (showAuditAndAds && this.report.activePhotoCategories.includes('audit')) {
          this.categories.push(new ReportFilesGroup({ categoryKey: 'audit', title: 'АУДИТ' }))
        }
        if (!this.isAudit && showAuditAndAds && this.report.activePhotoCategories.includes('advertisements')) {
          this.categories.push(new ReportFilesGroup({ categoryKey: 'advertisements', title: 'РЕКЛАМНЫЕ ОБЪЯВЛЕНИЯ' }))
        }
        if ((!this.isAudit || this.report.showAuditRemarks) && this.report.activePhotoCategories.includes('forAuditRequest')) {
          this.categories.push(new ReportFilesGroup({ categoryKey: 'forAuditRequest', title: 'ЗАМЕЧАНИЯ ПО АУДИТУ' }))
        }
        if (this.$d_hasFullAccess()) {
          this.categories.push(new ReportFilesGroup({ categoryKey: 'other', title: 'ДРУГОЕ' }))
        }
      }

      const filesGroupsContainer = this.report.filesGroupsContainers[this.FILES_PROPERTY]
      filesGroupsContainer.addFilesGroups(this.categories.slice())
      this.filesGroupsContainer = filesGroupsContainer

      // const filesGroupOther = filesGroupsContainer.getFilesGroup('other')
      // if (filesGroupOther) {
      //   this.categories.push(filesGroupOther)
      // }

      const user = this.$store.getters.getUser
      this.categoriesMap = {}
      this.categories.forEach(filesGroup => {
        let required = this.report.requiredPhotoCategories.includes(filesGroup.categoryKey)
        if (required && filesGroup.categoryKey === 'additionalVehicles') {
          required = this.hasForkliftTrucks
        }
        this.$set(filesGroup, 'required', required)
        this.$set(filesGroup, 'mode', 'view')

        if (filesGroup.remarkIndex == null) {
          const remarkIndex = this.report.remarks.findIndex(remark => remark.code === filesGroup.key)
          filesGroup.remarkIndex = remarkIndex !== -1 ? remarkIndex : null
        } else if (filesGroup.remarkIndex === -1) {
          filesGroup.remarkIndex = null
        }

        if (filesGroup.categoryKey !== 'video') {
          filesGroup.contentType = 'image'
        } else {
          filesGroup.contentType = 'video'
        }

        const self = this
        filesGroup.enrichmentFn = function (document) {
          const description = []
          const serviceObject = self.serviceObject
          if (serviceObject) {
            description.push({ name: 'Объект', value: serviceObject.name })
          }
          description.push({ name: 'Адрес', value: self.report.address })
          if (serviceObject && serviceObject.location) {
            description.push({ name: 'Координаты', value: serviceObject.location.lat + ', ' + serviceObject.location.lon })
          }

          if (!user.hasSystemRoleStrict('publicationRead') && !user.restrictedAccess) {
            if (document.time) {
              description.push({ name: `Время загрузки ${self.getContentTypeName(filesGroup)}`, value: formatTime(document.time) })
            }
            if (document.originalTime) {
              description.push({ name: `Оригинальное время создания ${self.getContentTypeName(filesGroup)}`, value: formatTime(document.originalTime) })
            }
            description.push({ name: 'Исполнитель', value: self.executorName })
            if (document.description && document.description.length) {
              description.push(...document.description)
            }
          }

          return {
            name: document.altName || document.name, // TODO FileDocument - name
            description: description
          }
        }

        this.categoriesMap[filesGroup.key] = filesGroup
      })

      this.report.documents.sort((a, b) => a.time - b.time)

      if (this.report.documents) {
        this.pushFiles(this.report.documents)
      }

      if (this.hideEmptyOnReadonly && this.readonly) {
        this.categories = this.categories.filter(category => {
          return category.files.length > 0
        })
      }
      if (this.hideCategories && this.hideCategories.length) {
        this.categories = this.categories.filter(category => {
          return !this.hideCategories.includes(category.key)
        })
      }

      let allFilesNumber = 0
      this.categories.forEach(category => {
        allFilesNumber += category.files.length

        if (category.files.length > 0) {
          this.$set(this.expansionCategories, category.key, true)
          if (!this.collapsedAndNoEdit) {
            this.categoriesCollapsePanel.push(category.key)
          }
        } else {
          this.$set(this.expansionCategories, category.key, false)
        }
        this.$set(this.loadingFromMessengers, category.categoryKey, false)
      })

      this.$nextTick(() => {
        this.initialized = true
        this.$nextTick(() => {
          this.$emit('update:files-number', allFilesNumber)
          this.onRemarkChanged()
        })
      })
    },
    getContentTypeName: function (filesGroup) {
      return filesGroup.contentType === 'image' ? 'фото' : 'видео'
    },
    onRotateSelectedImages: function (right = true) {
      this.filesGroupsContainer.rotateSelectedImages(right)
    },
    onCancelCategoryModeEdit: function (category) {
      category.mode = 'view'
      category.clearSelection()
    },
    onAddRemarkForSelectedFiles: function (category) {
      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            let fileWrappers
            if (category) {
              fileWrappers = category.getSelectedFiles()
            } else {
              fileWrappers = this.filesGroupsContainer.getSelectedFiles()
            }

            const newRemarks = []
            fileWrappers.forEach((fileWrapper, i) => {
              const fileIndex = category.findFileIndexById(fileWrapper.document.id)
              const remark = newRemarks.find(remark => remark.code === fileWrapper.document.category)
              if (remark != null) {
                remark.documentsIds.push(fileWrapper.document.id)
                remark.filesText += `, ${fileIndex + 1}`
              } else {
                const remark = {
                  active: true,
                  code: fileWrapper.document.category,
                  comment: data.comment,
                  important: data.important,
                  documentsIds: [fileWrapper.document.id],
                  filesText: `№: ${fileIndex + 1}`
                }
                newRemarks.push(remark)
              }
            })

            this.report.imagesRemarks.push(...newRemarks)

            if (category) {
              category.mode = 'view'
              category.clearSelection()
            } else {
              this.filesGroupsContainer.clearSelection()
            }
            this.onRemarkChanged()
          }
        },
        header: 'Замечание',
        propsConfig: {
          important: { type: 'boolean', label: 'Важное замечание', value: false },
          comment: { type: 'text', label: 'Комментарий', value: '' }
        },
        buttons: { yes: 'Добавить', cancel: 'Отмена' }
      })
    },
    onAskRemoveRemark: function (file) {
      const dialog = this.$d.dialog(this).show({
        maximized: false,
        contentComponent: ReportImageRemark,
        headerLabel: 'Замечания к фото',
        contentProps: {
          remarks: file.remarks,
          file: file,
          reportRoles: this.reportRoles,
          reportActionsAccess: this.report.actionsAccess,
          imagesRemarks: this.report.imagesRemarks,
          categories: this.categories,
          readonly: !this.report.actionsAccess.editRemarks
        },
        componentHandlers: {
          'remark-changed': () => {
            this.onRemarkChanged()
          },
          close: () => {
            dialog.hide()
          }
        }
      })
    },
    onDownloadAllImages: function () {
      let url = '/service/delta/document/loadAll/' + this.report.id
      if (this.report.reports) {
        url = url + '?properties=' + encodeURI(JSON.stringify({ multiple: true }))
      }
      downloadFile(url)
    },
    downloadFilesFromMessengers: async function (categoryKey) {
      this.loadingFromMessengers[categoryKey] = true
      return axiosGet({
        url: 'service/delta/employee/getMessengerPhotos?employeeId=' + (this.user.employee ? this.user.employee.id : this.user.systemUser.properties.$id) + '&reportId=' + this.report.id,
        onSuccess: (response) => {
          return response.data
        }
      }).finally(() => {
        this.loadingFromMessengers[categoryKey] = false
      })
    },
    uploadFilesFromMessengers: async function (selectedPhotos) {
      Object.keys(selectedPhotos).forEach(category => {
        if (selectedPhotos[category].length) {
          const formData = new FormData()

          formData.append('id', this.report.id)
          formData.append('category', category)
          formData.append('files', selectedPhotos[category])

          return axiosPost({
            url: '/service/delta/report/document/uploadMessenger',
            data: formData,
            onSuccess: (response) => {
              this.$q.notify({
                type: 'positive',
                message: 'Загружено из мессенджера: ' + (response.data.result ? response.data.result.length : 0),
                progress: true,
                timeout: 3000
              })
            },
            onFailure: ''
          })
        }
      })
    },
    onUploadFromMessengers: function (categoryKey) {
      this.downloadFilesFromMessengers(categoryKey).then(files => {
        const dialog = this.$d.dialog(this).show({
          maximizedOnNarrow: true,
          persistent: true,
          contentWidth: 800,
          headerLabel: this.categories.find(cat => cat.categoryKey === categoryKey).title + ' - загрузка из мессенджера',
          contentComponent: FilesFieldUploadFromMessengers,
          contentProps: {
            files: files.filter(file => file.photoCategory === categoryKey),
            uploadFilesFn: this.uploadFilesFromMessengers,
            employees: this.report.brigadeEmployees
          },
          componentHandlers: {
            upload: () => {
              dialog.hide()
              this.onLoadedFromMessengers()
            },
            cancel: () => {
              dialog.hide()
            }
          }
        })
      })
    },
    onLoadedFromMessengers: function () {
      this.$emit('report-updated')
    },
    getRemarkIconClass: function (remarks) {
      let result = ''
      if (remarks.filter(r => r.active).some(r => r.important)) {
        result += ' bg-negative'
      } else if (remarks.filter(r => r.active).some(r => !r.done) || !this.reportRoles.roleExecutor) {
        result += ' bg-warning'
      } else {
        result += ' bg-positive'
      }
      return result
    }
  }
}

